import React from "react";

const Animate = ({
  children,
  play,
  duration,
  timing,
  delay,
  translateX,
  translateY,
  fadeIn,
}) => {
  return (
    <div
      style={{
        "--translateX": translateX || "0vw",
        "--translateY": translateY || "0vh",
        "--delay": delay || "0s",
        "--timing": timing || "ease-in-out",
        "--duration": duration || "0.5s",
        transformOrigin: "50% 50%",
        transform: `translate3d(${play ? "0" : "var(--translateX)"}, ${play ? "0" : "var(--translateY)"}, 0)`,
        opacity: `${(fadeIn && play) ? "1" : "0.01"}`,
        transition: "all var(--duration) var(--timing) var(--delay)"
      }}
    >
      {children}
    </div>
  );
};

export default Animate;
